import portrait from './portrait.json';
import landscape from './landscape.json';
import init from './default.json';

export default {
  portrait,
  landscape,
  init,
};



// WEBPACK FOOTER //
// ./src/config/templates/layouts/index.jsx